import { render, staticRenderFns } from "./ProductPriceMatrix.vue?vue&type=template&id=5efe12bc&scoped=true&"
import script from "./ProductPriceMatrix.vue?vue&type=script&lang=js&"
export * from "./ProductPriceMatrix.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceMatrix.vue?vue&type=style&index=0&id=5efe12bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe12bc",
  null
  
)

export default component.exports